import { render, staticRenderFns } from "./LPFilterProfile.vue?vue&type=template&id=495e5059&scoped=true&"
import script from "./LPFilterProfile.vue?vue&type=script&lang=js&"
export * from "./LPFilterProfile.vue?vue&type=script&lang=js&"
import style0 from "./LPFilterProfile.vue?vue&type=style&index=0&id=495e5059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495e5059",
  null
  
)

export default component.exports